module.exports = __webpack_public_path__ + "static/img/6.53baf2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/sp/6.png
// module id = +xCU
// module chunks = 0